import React from "react";
import {
  CardContent,
  CardMedia,
  Paper,
  Typography,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "1em",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    height: "26.5em",
    width: "30em",
    textAlign: "center",
    border: "0.06em solid #D1DBE3",
    [theme.breakpoints.up("xl")]: {
      height: "28.5em",
      width: "32em",
    },
  },
  img: {
    width: "6em",
    height: "5em",
    margin: "4em auto 0 auto",
    borderRadius: "0.3em",
  },
  content: {
    justifyContent: "center",
    textAlign: "center",
    width: "24.5em",
    margin: "2em auto auto auto",
  },
  header: {
    margin: "1em auto",
  },
  paragraph: {
    lineHeight: "1.5em",
    textAlign: "center",
  },
}));

const NtkCard = ({ image, header, paragraph }) => {
  const classes = useStyles();
  return (
    <Paper
      data-testid="ntkCard"
      key="ntkCard"
      className={classes.paper}
      elevation={0}
    >
      <CardMedia className={classes.img} image={image} />
      <CardContent className={classes.content}>
        <Typography className={classes.header} color="primary" variant="h3">
          {header}
        </Typography>
        <Typography
          className={classes.paragraph}
          color="secondary"
          variant="subtitle1"
        >
          {paragraph}
        </Typography>
      </CardContent>
    </Paper>
  );
};

export default NtkCard;
